import request from '@/utils/request'

//  获得消息分页
 export function getStationMessagePage(query) {
    return request({
      url: '/system/shop/msg/page',
      method: 'get',
      params: query
    })
  }

  export function updateReadStatus(id) {
    return request({
      url: '/system/shop/msg/get?id='+id,
      method: 'get'
    })
  }

